import axios from '../api' // 倒入 api
export const test = {
  // 获取token
  flashToken: data => {
    return axios({
      url: '/coi/api/v1/flashToken',
      method: 'post',
      base: 'TEST',
      // userAuthorization,
      data
    })
  },
  // 2.投标人关联关系报告出具
  associationAnalysisReport: (data, userAuthorization) => {
    return axios({
      url: '/gen/generatePDF/v1/associationAnalysisReport',
      method: 'post',
      base: 'TEST',
      json: true,
      userAuthorization,
      data
    })
  },
  // 2.企业前置资格审查报告出具
  enterpriseQualificationReport: (data, userAuthorization) => {
    return axios({
      url: '/gen/generatePDF/v1/enterpriseQualificationReport',
      method: 'post',
      base: 'TEST',
      userAuthorization,
      data
    })
  },
}
export default test